import { createContext, useContext } from 'react';

/**
 * I due posti dove gli avvisi che arrivano da soli si mettono (Alex,
 * 26 settembre 2026, blocco 2 punti B e N).
 *
 *  - `angolo`: una colonna in basso a destra (Layout, .rm-angolo). Ci
 *    stanno il Promemoria e la pila dei ritardi o delle attese, UNO
 *    SOPRA L'ALTRO: stanno nella stessa colonna, quindi non possono
 *    sovrapporsi per costruzione, non per un calcolo di posizioni che
 *    un giorno sbaglia. Fino a quel giorno il Promemoria stava in alto a
 *    destra e copriva la barra (il nome dell'utente, «Esci»), la pila in
 *    basso, e con tutti e due aperti su un telefono si coprivano fra loro.
 *  - `barra`: un posto nella barra in alto, dove da tre ritardi in su
 *    compare un solo pulsante «N pazienti in ritardo». Nella barra non
 *    copre mai un pulsante della scheda.
 *
 * I nodi li crea Layout; chi disegna un avviso ci entra con un portale.
 * Finche' non ci sono (prima del primo disegno) non si mostra niente.
 *
 * `promemoria` (stile «Console», fase 1, 2/10/2026): la campanella degli
 * avvisi nella barra in alto. Il numero e' quello dei promemoria arrivati
 * che il Promemoria dell'angolo sta gia' mostrando (AlertNotifier lo
 * comunica con `segnala(n)`): nessuna seconda chiamata al server, nessun
 * conteggio diverso. `aperto`/`apri` sono lo stato del Promemoria, tenuto
 * nel Layout perche' la campanella lo possa aprire.
 */
export const PostiAvvisi = createContext({ angolo: null, barra: null, promemoria: null });

export const usePostiAvvisi = () => useContext(PostiAvvisi);
